import React, { useState, useEffect } from "react";

import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import MDBadge from "components/MDBadge";

import Moment from "react-moment";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import DataTable from "examples/Tables/DataTable";
import { statusColor } from "../../../config/enum";

import { getBilling } from "../../../api/billings";

import CreateEditBillings from "../CreateEditBillings";

// Material Dashboard 2 PRO React contexts
import { useMaterialUIController } from "context";

import { useSelector } from "react-redux";
import { canEditOrder } from "../../../utils/permissions";

export default function BillingTable({ device, user }) {
  const currentOrder = useSelector((state) => state.orders.currentOrder);
  const canEdit = canEditOrder(user, currentOrder);
  const [billings, setBillings] = useState([]);
  const [billingRows, setBillingRows] = useState([]);

  const billingColumns = [
    { Header: "Facture", accessor: "status", align: "center", width: "15%" },
    { Header: "Pourcentage", accessor: "percentage", align: "center", width: "5%" },
    { Header: "Description", accessor: "description", align: "center" /* , width: "20%" */ },
    { Header: "Statut", accessor: "status_date", align: "left" /* , width: "33%" */ },
  ];

  async function fetchBillings() {
    const response = await getBilling(device.device_id);
    setBillings(response.data);
  }

  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  useEffect(() => {
    fetchBillings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setBillingRows(generateRows);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [billings, darkMode]);

  function generateRows() {
    const rows = [];
    for (let i = 0; i < billings.length; i++) {
      rows.push({
        status: (
          <MDTypography component="a" variant="button" fontWeight="medium">
            {i + 1}
          </MDTypography>
        ),
        status_date: (
          <MDBox display="flex" alignItems="left" flexDirection="column">
            {billings[i].status !== "Non facturée" ? (
              <MDBadge
                sx={{
                  ".MuiBadge-badge": {
                    margin: "0px",
                    background:
                      billings[i].status === "À facturer" &&
                      "linear-gradient(195deg, #F2DA00, #D8C300)",
                    color: billings[i].status === "À facturer" && "#344767",
                  },
                }}
                badgeContent={billings[i].status}
                color={statusColor[billings[i].status]}
                variant="gradient"
                size="sm"
              />
            ) : (
              <MDTypography component="span" variant="button" fontWeight="medium">
                {billings[i].status}
              </MDTypography>
            )}
            {billings[i].status === "Facturée" && (
              <>
                <MDTypography component="span" sx={{ fontWeight: "400" }} variant="button">
                  {billings[i].situation_date === null ? (
                    "Date inconnue"
                  ) : (
                    <>
                      <MDTypography component="span" sx={{ fontWeight: "800" }} variant="button">
                        le{" "}
                      </MDTypography>
                      <Moment format="DD/MM/YYYY">{billings[i].situation_date}</Moment>
                    </>
                  )}
                </MDTypography>
                <MDBox mt={-0.5}>
                  {billings[i].bill_number === null ? (
                    <>
                      <MDTypography component="span" sx={{ fontWeight: "800" }} variant="button">
                        numéro:{" "}
                        <MDTypography component="span" sx={{ fontWeight: "400" }} variant="button">
                          inconnu
                        </MDTypography>
                      </MDTypography>
                    </>
                  ) : (
                    <>
                      <MDTypography component="span" sx={{ fontWeight: "800" }} variant="button">
                        numéro:{" "}
                        <MDTypography component="span" sx={{ fontWeight: "400" }} variant="button">
                          {billings[i].bill_number}
                        </MDTypography>
                      </MDTypography>
                    </>
                  )}
                </MDBox>
              </>
            )}
            {billings[i].status === "À facturer" && (
              <MDTypography component="span" sx={{ fontWeight: "400" }} variant="button">
                {billings[i].waiting_date === null ? (
                  "Date inconnue"
                ) : (
                  <>
                    <MDTypography component="span" sx={{ fontWeight: "800" }} variant="button">
                      depuis le{" "}
                    </MDTypography>
                    <Moment format="DD/MM/YYYY">{billings[i].waiting_date}</Moment>
                  </>
                )}
              </MDTypography>
            )}
            {(billings[i].status === "Payée" || billings[i].status === "Partiellement payée") && (
              <>
                {billings[i].bill_number === null ? (
                  <>
                    <MDTypography component="span" sx={{ fontWeight: "800" }} variant="button">
                      numéro:{" "}
                      <MDTypography component="a" sx={{ fontWeight: "400" }} variant="button">
                        inconnu
                      </MDTypography>
                    </MDTypography>
                  </>
                ) : (
                  <>
                    <MDTypography component="span" sx={{ fontWeight: "800" }} variant="button">
                      numéro:{" "}
                      <MDTypography component="span" sx={{ fontWeight: "400" }} variant="button">
                        {billings[i].bill_number}
                      </MDTypography>
                    </MDTypography>
                  </>
                )}
              </>
            )}
          </MDBox>
        ),
        description: (
          <MDTypography component="a" variant="button" fontWeight="medium">
            {billings[i].situation_description}
          </MDTypography>
        ),
        percentage: (
          <MDBox display="flex" alignItems="center" flexDirection="column">
            <MDBox ml={0.5}>
              <MDTypography component="a" variant="button" fontWeight="medium">
                {billings[i].required_percentage}%
              </MDTypography>
            </MDBox>
          </MDBox>
        ),
      });
    }
    return rows;
  }
  return (
    <Grid item xs={12} height="100%">
      <Card sx={{ height: "100%" }}>
        <MDBox
          mx={2}
          mt={-3}
          py={1.5}
          px={2}
          variant="gradient"
          borderRadius="lg"
          sx={{
            background: !darkMode ? "linear-gradient(195deg, #364c70, #273956)" : "white",
            boxShadow: darkMode ? "0 1px 4px 1px white" : "0 1px 4px 1px #344767",
            display: "flex",
            verticalAlign: "middle",
          }}
        >
          <MDTypography
            variant="h5"
            style={{
              width: "50%",
              lineHeight: "2.4rem",
              display: "tableCell",
              verticalAlign: "middle",
            }}
            color={darkMode ? "inherit" : "white"}
          >
            Situations de facturation
          </MDTypography>
          {canEdit && (
              <Grid style={{ textAlign: "right", width: "50%" }}>
                {user && user.role !== "Contremaître" && (
                  <CreateEditBillings
                    edit={false}
                    device={device}
                    billings={billings}
                    setBillings={setBillings}
                  />
                )}
                {billings.length > 0 && (
                  <CreateEditBillings
                    user={user && user}
                    edit
                    device={device}
                    billings={billings}
                    setBillings={setBillings}
                  />
                )}
              </Grid>
            )}
        </MDBox>

        {billingRows && billingRows.length === 0 ? (
          <MDBox
            pt={0.75}
            sx={{ textAlign: "center", paddingTop: 3, paddingBottom: 2, height: "100%" }}
          >
            <MDTypography
              component="a"
              variant="h5"
              color={darkMode ? "white" : "inherit"}
              style={{
                display: "tableCell",
                verticalAlign: "middle",
              }}
            >
              Aucune facture n'a encore été ajouté
            </MDTypography>
          </MDBox>
        ) : (
          <MDBox
            pt={0.75}
            sx={{
              height: "100%",
              "div.MuiTableContainer-root": {
                height: "100%",
                display: "flex",
              },
            }}
          >
            <DataTable
              size="medium"
              table={{ columns: billingColumns, rows: billingRows }}
              isSorted={false}
              entriesPerPage={false}
              showTotalEntries={false}
              noEndBorder
            />
          </MDBox>
        )}
      </Card>
    </Grid>
  );
}
